import React from 'react';
import { 
	object, 
	func, 
	string,
	array,
	bool 
} from 'prop-types';
import Link from 'redux-first-router-link';
import '../../../i18n';
import { withNamespaces } from 'react-i18next';
import {ROUTES} from '../../../constants';
import style from './style';


const Recipe = ({value,t}) =>{
	const {objectID, name} = value;
	return (
		<style.Recipe>
			<div id='link'>
				<Link to={{ type: ROUTES.RECIPE_DETAIL, payload: { recipeId : objectID } }}>{name}</Link>
			</div>
		</style.Recipe>
	);
};
Recipe.propTypes = {
	value : object.isRequired
};

const Score = ({value,t}) =>{
	const {questionCount, passed} = value;
	const pcnt = Math.round((questionCount > 0 ? passed / questionCount : 0)*100);
	return (
		<style.Score pcnt={pcnt}>
			<span>{pcnt}</span>
		</style.Score>
	);
};
Score.propTypes = {
	value : object.isRequired
};

const Presenter = ({
	className,
	recipeScores,
	showAllScores ,
	handleMoreScore,
	hasScore ,
	t,
}) => {
	let Table = hasScore ? (
		<style.ActivityHistory>
			<table>
				<thead>
					<tr>
						<th>{t('home.Recipe')}</th>
						<th>{t('home.Score')}</th>
						<th>{t('home.LastExecution')}</th>
					</tr>
				</thead>
				<tbody>
					{recipeScores.map(score=>{
						return (
							<tr key={score.date}>
								<td><Recipe value={score} t={t}/></td>
								<td><Score value={score} t={t}/></td>
								<td>{score.date}</td>
							</tr>
						);
					})}
				</tbody>
			</table>
			<style.LOD>
				<style.TextButton onClick={handleMoreScore(!showAllScores)}>
					{showAllScores ? t('home.ShowLess'): t('home.ShowMore')}
				</style.TextButton>
			</style.LOD>
		</style.ActivityHistory>
	) : (<style.NoActivity>
		<h4>{t('home.NoFav')}</h4>
	</style.NoActivity>);
	return (
		<style.Wrapper className={className}>
			<h3>
				<style.IconWrapper><style.CalendarIcon/></style.IconWrapper>
				{t('home.ActivityHistory')}
			</h3>
			{Table}
		</style.Wrapper>
	);
};
	

Presenter.propTypes = {
	className : string,
	recipeScores : array.isRequired,
	showAllScores : bool.isRequired,
	handleMoreScore : func.isRequired,
	hasScore : bool.isRequired,
};

export default withNamespaces()(Presenter);